module.exports = __webpack_public_path__ + "img/search-btn.43852e6.png";